import React, { useState } from 'react';

function DemoPage() {
  const [isVideoOpen, setIsVideoOpen] = useState(false);

  const openVideoModal = () => setIsVideoOpen(true);
  const closeVideoModal = () => setIsVideoOpen(false);

  return (
    <div>
      <button onClick={openVideoModal} className='demo-btn'>Get Demo</button>

      {isVideoOpen && (
        <div style={styles.modal}>
          <div style={styles.modalContent}>
            <span onClick={closeVideoModal} style={styles.closeButton}>×</span>
            <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
              <iframe
                src="https://www.youtube.com/embed/n9hId1L9NWU?autoplay=1"
                title="YouTube video player"
                frameBorder="0"
                allow="autoplay; encrypted-media"
                allowFullScreen
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                }}
              ></iframe>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const styles = {
  modal: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
  },
  modalContent: {
    backgroundColor: 'white',
    padding: '0',
    borderRadius: '8px',
    position: 'relative',
    maxWidth: '800px',
    width: '90%',
  },
  closeButton: {
    position: 'absolute',
    top: '10px',
    right: '15px',
    cursor: 'pointer',
    fontSize: '24px',
    fontWeight: 'bold',
    zIndex: 10,
    color: '#333',
  },
};

export default DemoPage;
